import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import DirectionIcons from '../../shared/icons/DirectionIcons';
import ROUTING_RULE_HISTORY from '../queries/group-setting-routing-rule-history.graphql';

const columns = [
  { id: 'changeInitiatorEmail', name: 'Changed by' },
  { id: 'updatedAt', name: 'Date/Time' },
  { id: 'specialtyName', name: 'Service' },
  { id: 'routingRuleName', name: 'Routing Rule' }
];

const sortingMethod = (data, columnId, direction) => {
  const sortingDirection = direction ? 1 : -1;

  switch (columnId) {
    case 'updatedAt':
      return [...data].sort((a, b) => sortingDirection * (new Date(b.updatedAt) - new Date(a.updatedAt)));
    case 'changeInitiatorEmail':
      return [...data].sort((a, b) => {
        const aEmail = a['changeInitiatorEmail'] || '';
        const bEmail = b['changeInitiatorEmail'] || '';
        return sortingDirection * bEmail.localeCompare(aEmail);
      });
    case 'routingRuleName':
    case 'specialtyName':
      return [...data].sort((a, b) => {
        const aValue = a[columnId] || '';
        const bValue = b[columnId] || '';
        return sortingDirection * bValue.localeCompare(aValue);
      });
  }
};

const RoutingRulesAuditLog = ({ groupId }) => {
  const [sort, setSort] = useState({ id: 'updatedAt', direction: true });
  const [localData, setLocalData] = useState([]);

  const { loading: routingRuleHistoryLoading, data: routingRuleHistoryData } = useQuery(ROUTING_RULE_HISTORY, {
    variables: { groupId: groupId.toString() },
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (routingRuleHistoryData) {
      const sortedData = sortingMethod(routingRuleHistoryData.groupRoutingRuleHistory, sort.id, sort.direction);
      setLocalData(sortedData);
    }
  }, [routingRuleHistoryData]);

  const handleSort = columnId => {
    const direction = columnId === sort.id ? !sort.direction : false;
    const sortedData = sortingMethod(routingRuleHistoryData.groupRoutingRuleHistory, columnId, direction);

    setLocalData(sortedData);
    setSort({ id: columnId, direction });
  };

  if (routingRuleHistoryLoading) return 'Loading...';

  return (
    <div className="routing-rule-audit">
      <h2>Routing rules audit log</h2>
      <table>
        <thead>
          <tr>
            {columns.map(column => (
              <th onClick={() => handleSort(column.id)} key={column.id}>
                <div>
                  <p>{column.name}</p>
                  <DirectionIcons active={column.id === sort.id} direction={sort.direction} />
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!isEmpty(localData) &&
            localData.map((rowData, idx) => (
              <tr key={idx}>
                <td className="w-1/4">{rowData.changeInitiatorEmail}</td>
                <td className="w-1/4">{moment(rowData.updatedAt).format('MM/DD/YYYY HH:mm:ss')}</td>
                <td className="w-1/4">{rowData.specialtyName || 'N/A'}</td>
                <td className="w-1/4">
                  {rowData.routingRuleId ? rowData.routingRuleName : 'The routing rule is unassigned'}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isEmpty(localData) && <p className="my-5">No associations have been made</p>}
    </div>
  );
};

export default RoutingRulesAuditLog;
